import * as GameModel from "../../models/GameModel";

export default class StaticText extends Phaser.Text
{
    constructor(game, config)
    {
        var position = config.transform.position;
        super(game, position.x, position.y, "", config.style);
        this.anchor.setTo(0.5, 0.5);
        this.smoothed = false;
        this.config = config;
        this.updateTextLocalization();
    }

    updateTextLocalization()
    {
        // Todo: this should be in an xml or something?
        if(GameModel.data.english)
        {
            this.setText(this.config.text.english);
        }
        else
        {
            this.setText(this.config.text.spanish);
        }
    }
}
